import {
  DHR_CLEAR_DATA,
  EMPLOYEE_CLEAR_DATA,
  LMS_CLEAR_DATA,
  TRAK_CLEAR_DATA,
  RC_CLEAR_DATA,
  ILT_CLEAR_DATA,
  REPORTS_CLEAR_DATA,
  // NEWLMS_CLEAR_DATA,
} from "./config";
import { clearAllFilterData } from "./store/slices/filterDataSlice";

const loadIframeWithTimeout = (
  iframeSrc,
  iframeStyle,
  timeoutDuration = 6000
) => {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement("iframe");
    iframe.src = iframeSrc;
    iframe.height = iframeStyle.height;
    iframe.width = iframeStyle.width;
    iframe.style.display = iframeStyle.display;

    const timeout = setTimeout(() => {
      console.warn(`Iframe load timed out: ${iframeSrc}`);
      reject("Timed out");
    }, timeoutDuration);

    iframe.addEventListener("load", () => {
      clearTimeout(timeout);
      resolve();
    });

    iframe.addEventListener("error", () => {
      clearTimeout(timeout);
      console.warn(`Iframe failed to load: ${iframeSrc}`);
      reject("Load failed");
    });

    document.body.appendChild(iframe);
  });
};

const loadIframeSafely = async (iframeSrc) => {
  const iframeStyles = {
    height: "0",
    width: "0",
    border: "0",
    display: "none",
  };
  try {
    await loadIframeWithTimeout(iframeSrc, iframeStyles);
  } catch (error) {
    console.error(`Failed to load iframe for ${iframeSrc}:`, error);
  }
};

export const processIframes = async (LeftMenuData, dispatch) => {
  dispatch(clearAllFilterData());
  //changing logic
  const iframePromises = [loadIframeSafely(EMPLOYEE_CLEAR_DATA)];
  const iframeMappings = {
    "Trak Learning": TRAK_CLEAR_DATA,
    "Trak Coaching": TRAK_CLEAR_DATA,
    DelegateHR: DHR_CLEAR_DATA,
    TraineryLMS: LMS_CLEAR_DATA,
    "Review Cloud": RC_CLEAR_DATA,
    "Trainery ILT": ILT_CLEAR_DATA,
    Reports: REPORTS_CLEAR_DATA,
    // "LMS Beta": NEWLMS_CLEAR_DATA,
  };
  const loadedIframes = [];

  LeftMenuData?.forEach((menuItem) => {
    if (iframeMappings[menuItem?.key_name]) {
      if (!loadedIframes.includes(iframeMappings[menuItem?.key_name])) {
        loadedIframes.push(iframeMappings[menuItem?.key_name]);
        iframePromises.push(
          loadIframeSafely(iframeMappings[menuItem?.key_name])
        );
      }
    }

    menuItem?.drop_down_data?.forEach((dropItem) => {
      if (iframeMappings[dropItem?.key_name]) {
        if (!loadedIframes.includes(iframeMappings[dropItem?.key_name])) {
          loadedIframes.push(iframeMappings[dropItem?.key_name]);
          iframePromises.push(
            loadIframeSafely(iframeMappings[dropItem?.key_name])
          );
        }
      }
    });
  });
  await Promise.allSettled(iframePromises);
};
